<template>
  <Bar
    id="my-chart-bar"
    :options="chartOptions"
    :data="chartData"
    :width="width"
  />
</template>

<script>
import { Bar } from "vue-chartjs";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement
);

export default {
  name: "BarChart",
  components: {
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartData: {
        // type: "bar",
        
        labels: [
          "Radios + GD",
          ["Free-to-air TV + GD"],
          "Live concerts",
          "Video streaming",
          "Pay TV",
          "Audio streaming",
          "Background music",
          "Clubs",
          "Live Music",
          "Carnival",
          "Cinema",
          "Digital Services",
          "June Festivals",
        ],
        datasets: [
          {
            minBarLength: 35,
            
            backgroundColor: [
              "rgba(236,22,81, 1)",
              "rgba(226,22,81, 0.9)",
              "rgba(236,22,81, 0.8)",
              "rgba(236,22,81, 0.7)",
              "rgba(236,22,81, 0.6)",
              "rgba(236,22,81, 0.5)",
              "rgba(236,22,81, 0.6)",
              "rgba(236,22,81, 0.5)",
              "rgba(236,22,81, 0.4)",
              "rgba(236,22,81, 0.4)",
              "rgba(236,22,81, 0.4)",
              "rgba(236,22,81, 0.6)",
              "rgba(236,22,81, 0.6)"
            ],
            hoverBackgroundColor: [
              "rgba(189, 18, 65, 1)",
              "rgba(189, 18, 65, 0.9)",
              "rgba(189, 18, 65, 0.8)",
              "rgba(189, 18, 65, 0.7)",
              "rgba(189, 18, 65, 0.6)",
              "rgba(189, 18, 65, 0.5)",
              "rgba(189, 18, 65, 0.6)",
              "rgba(189, 18, 65, 0.5)",
              "rgba(189, 18, 65, 0.4)",
              "rgba(189, 18, 65, 0.4)",
              "rgba(189, 18, 65, 0.4)",
              "rgba(189, 18, 65, 0.6)",
              "rgba(189, 18, 65, 0.6)"
            ],
            data: [
              18.5, 15.56, 14.72, 13.43, 11.10, 10.11, 4.25, 3.21, 3.06, 1.92, 1.80, 0.59, 0.50,
            ],
            borderWidth: 0,
          },
        ],
      },
      chartOptions: {
        indexAxis: 'y',
        scales: {
          y: {
            ticks: { 
              color: '#EC1651', 
              font : {
                size : 12,    
                family: 'sanuk-bold'
              }
            }
          }
        },
        plugins: {
          tooltip: {
            displayColors: true,
            backgroundColor: "#FFF",
            bodyColor: "#000",
            titleColor: " #000",
            padding: 10,
            callbacks: {
              label: (x) => {
                // console.log(x);
                return `${x.formattedValue.replaceAll(",", ".")}%`;
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            color: 'white',
            formatter: function(value) {
              return  value + '%';
            }
          },
        },
        animation: {
          animateScale: true,
        },
        responsive: true,
        maintainAspectRatio: false,
        hoverOffset: 5,
      },
    };
  },
};
</script>
